<!--
 * @Author: MX
 * @Date: 2020-07-30 14:24:16
 * @Description: 登录页
-->
<template>
  <div class="login" :class="carouselActive === 0 ? 'black' : ''">
    <div class="brower-contain" v-if="!isChrome">
      <span class="brower-contain-text">{{ $lang('欢迎使用JFS科技信息平台') }}</span>
      <span class="brower-contain-text">{{ $lang('请先下载安装谷歌浏览器') }}</span>
      <a class="brower-contain-btn" target="blank" href="https://www.google.cn/chrome/">下载</a>
    </div>
    <i class="iconlogo iconfont logo-img"></i>
    <div class="lg-top">
      <template v-if="!isSetPassword">
        <div class="login-box" v-if="!isForgetPassword">
          <div class="title">JFS-VIP</div>
          <el-form ref="loginForm" :model="loginForm" :rules="rules" hide-required-asterisk>
            <el-form-item prop="account" :label="$lang('用户名')">
              <el-input :placeholder="$lang('请输入账号')" v-model="loginForm.account" type="text" autocomplete="off">
                <!-- <i slot="prefix" class="iconfont el-input__icon iconyonghuming"></i> -->
              </el-input>
            </el-form-item>
            <el-form-item prop="pwd" :label="$lang('密码')">
              <el-input :placeholder="$lang('请输入密码')" v-model="loginForm.pwd" :type="isShowPassword ? 'text' : 'password'" autocomplete="off">
                <!-- <i slot="prefix" class="iconfont el-input__icon iconmima1"></i> -->
                <div slot="suffix" class="toggleIcon" @click="toggleIcon">
                  <i class="iconfont icon-iconfont " :class="{ iconxianshi: isShowPassword, iconyincang: !isShowPassword }"></i>
                </div>
              </el-input>
            </el-form-item>
            <el-form-item prop="captcha" :label="$lang('验证码')">
              <el-input :placeholder="$lang('请输入验证码')" v-model="loginForm.captcha" autocomplete="off" maxlength="11">
                <!-- <i slot="prefix" class="iconfont el-input__icon iconyanzhengma1"></i> -->
                <i slot="suffix">
                  <img :src="verificationImg" alt="" @click="resetCode" style="position: relative;bottom: 1px;" />
                </i>
              </el-input>
            </el-form-item>
            <el-row>
              <el-checkbox v-model="remember" style="float:left">{{ $lang('记住账号') }}</el-checkbox>
              <!-- <span class="forget" @click="forgetPassword">{{$lang('忘记密码')}}</span> -->
            </el-row>
          </el-form>
          <el-button type="primary" class="login-btn" @click="submitForm('loginForm')" v-loading="loginLoading">{{ $lang('登 录') }}</el-button>
        </div>
        <div class="login-box" v-else>
          <ModifyPassword @reBack="forgetPassword"></ModifyPassword>
        </div>
      </template>

      <div class="login-box" v-if="isSetPassword">
        <SetPasswordCom @setpasswordSuc="setpasswordSuc"></SetPasswordCom>
      </div>
      <div class="logo_introduce">
        <!-- 添加国际化 -->
        <el-select class="lm-i18n" v-model="i18nValue" @change="i18nChange">
            <el-option v-for="item in langList" :key="item.value" :value="item.value" :label="item.local"></el-option>
        </el-select>
        <div class="introduce_main">
          {{ $lang('J&TCargo秉承“客户为本，效率为根”的使命，积极拥抱互联网，采用最先进的智能分拣设备，布局大数据、人工智能、云计算和物联网。全力打造健康，长久的企业。') }}
        </div>
        <img :src="vipBg" alt=""/>
      </div>
    </div>
    <div class="el-carousel"><img :src="bg1" alt="" width="100%" height="100%" /></div>
    <!-- <el-carousel height="100%" :initialIndex="carouselActive" trigger="click" :interval="6000" @change="e => (carouselActive = e)">
      <el-carousel-item v-for="item in carouselList" :key="item.key">
        <img :src="item.src" alt="" :key="item.key" width="100%" height="100%" />
      </el-carousel-item>
    </el-carousel> -->
    <div class="footer">
      {{ $lang('Copyright © 2019 - 2029 云路科技.All Rights Reserved') }}
    </div>
  </div>
</template>

<script type="text/javascript">
import bg1 from '@/assets/images/bg/bg4.png'
import vipBg from '@/assets/images/bg/vip_bg.png'
// import bg2 from '@/assets/images/bg/bg2.jpg'
// import bg3 from '@/assets/images/bg/bg3.jpg'
// import CountTo from 'vue-count-to'
import * as Api from '@api/base/public'
import { RULES } from '@utils/rules'
import { CryptoUtil } from '@/utils/crypto'
// import { LS } from '@utils/util'
import { RESPONSE_SUCCESS, MENU } from '@constants'
import ModifyPassword from './ModifyPassword'
import SetPasswordCom from './SetPasswordCom'
import { mapActions } from 'vuex'
export default {
  name: 'Login',
  components: { ModifyPassword, SetPasswordCom },
  data() {
    return {
      vipBg,
      bg1,
      menuList: [...MENU],
      carouselActive: 1,
      carouselList: [
        {
          key: 0,
          src: bg1,
        },
        // {
        //   key: 1,
        //   src: bg2,
        // },
        // {
        //   key: 2,
        //   src: bg3,
        // },
      ],
      isShowPassword: false,
      company: [
        { key: 0, name: this.$lang('转运中心'), val: 45, unit: '个', span: 4 },
        { key: 1, name: this.$lang('全国省市覆盖率'), val: 100, unit: '%', span: 8 },
        { key: 2, name: this.$lang('运输干线'), val: 300, unit: '+', span: 4 },
        { key: 3, name: this.$lang('长途运输车'), val: 500, unit: '+', span: 7 },
      ],
      loginForm: {
        account: '',
        pwd: '',
        captcha: '',
      },
      remember: false,
      verificationImg: '', // 验证码图片
      ctoken: '',
      isForgetPassword: false, // 是否忘记密码
      rules: {
        account: [{ required: true, message: this.$lang('用户名不能为空'), trigger: 'blur' }],
        pwd: [RULES.required, RULES.checkPassword],
        captcha: [RULES.required],
      },
      isSetPassword: false, // 首次登陆修改密码
      loginLoading: false, // 登录loading

      i18nValue: '',
    }
  },
  created() {
    this.getCode()
    this.init()
  },
  computed: {
    // 国际化语言
    lang() {
      return this.$store.state.base.lang
    },
    // 国际化列表
    langList() {
      return this.$store.state.base.langList
    },
    isChrome() {
      return navigator.userAgent.toLowerCase().match(/chrome/)
    },
  },
  watch: {
    lang: {
      handler(val, oldVal) {
        this.i18nValue = val
      },
      immediate: true,
    },
  },

  methods: {
    ...mapActions(['SET_USER', 'LOGIN_INIT', 'SET_SYSTEM_MENU', 'SET_LANG', 'SET_LANG_JSON']),
    // 初始化
    init() {
      // 在页面加载时从cookie获取登录信息
      const account = this.$common.getCookie('account')
      const password = this.$common.getCookie('pwd')

      // 如果存在赋值给表单，并且将记住密码勾选
      if (account) {
        this.loginForm.account = account
        this.loginForm.pwd = CryptoUtil.aesDecrypt(password)
        this.remember = true
      }
    },
    /**
     * @description 忘记密码
     */
    forgetPassword() {
      this.isForgetPassword = !this.isForgetPassword
      this.resetCode()
    },
    /**
     * 获取验证码
     */
    async getCode() {
      await Api.getCaptcha().then(res => {
        this.verificationImg = res.data.img
        this.ctoken = res.data.ctoken
      })
    },
    /**
     * 重新获取验证码
     */
    resetCode() {
      this.getCode()
    },
    // 登录提交
    async submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const { account, pwd, captcha } = this.loginForm || {}
          const returnCity = window.returnCitySN
          const ip = returnCity ? returnCity['cip'] || '' : ''
          const params = {
            account,
            pwd: this.$md5(pwd + 'jadada236t2').toUpperCase(),
            captcha,
            ctoken: this.ctoken,
            ip,
          }
          this.loginLoading = true
          Api.LOGIN(params).then(res => {
            if (res.code === 1) {
              this.loginLoading = false
              this.handleResForLogin(res)
            } else {
              this.loginLoading = false
              this.$message.error(res.msg)
              this.resetCode()
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 处理数据-登录成功后
    async handleResForLogin({ code, data, msg = '' } = {}) {
      // 请求成功
      if (code === RESPONSE_SUCCESS) {
        // 广播信息到其他同域名页面
        localStorage.setItem('YL_UPDATE', 'refreshOtherPage')
        // 数据为空
        if (!data) return
        // 解构对象
        const { firstLogin, type, isAdmin } = data
        // 去掉status判断（status：1启用2禁用）
        // 获取基础用户信息
        let user = { ...data }
        const token = data.token
        this.menuList.forEach(element => {
          if (type === 2 && element.routeName === 'userManage' && isAdmin === 0) {
            element.isShow = 2
          } else if (type === 1 || isAdmin === 1) {
            element.isShow = 1
          }
        })
        this.menuList = JSON.parse(JSON.stringify(this.menuList))
        // 递归权限列表
        this.LOGIN_INIT({ user, token, systemMenus: this.menuList }).then(res => {
          if (!firstLogin) {
            Api.UserDetail({ id: user.id }).then(res => {
              this.saveUserAccountInfoToCookie() // 记住密码
              if (res.code === RESPONSE_SUCCESS) {
                user = { ...data, ...res.data }
              }
              if (!user.contactMobile) {
                this.$router.push({ path: '/bindMobile' })
              } else {
                // 跳转路由
                this.$router.push({ path: '/index' })
                // 保存用户账号信息到cookie
                // this.saveUserAccountInfoToCookie() // 记住密码
                this.SET_USER(user) // 更新vuex的用户数据
                this.SET_SYSTEM_MENU(this.menuList)
              }
            })
          } else {
            localStorage.setItem('YL_TOKEN', '')
            localStorage.setItem('oldPwd', this.loginForm.pwd)
            // this.$router.push({ path: '/setPassword' })
            this.isSetPassword = true
          }
        })
      } else {
        this.resetVerify() // 重置验证码
        this.$message.error(msg)
      }
    },
    // 储存用户账号信息到cookie
    // saveUserAccountInfoToCookie() {
    //   // 判断用户是否勾选记住密码，如果勾选，向cookie中储存登录信息，
    //   // 如果没有勾选，储存的信息为空
    //   const { account, pwd } = this.loginForm
    //   if (this.remember) {
    //     if (this.$common.getCookie('pwd') === pwd) return
    //     this.$common.setCookie('account', account, 7)
    //     this.$common.setCookie('pwd', pwd, 7)
    //   } else {
    //     this.$common.setCookie('account', '')
    //     this.$common.setCookie('pwd', '')
    //   }
    // },
    /**
     * @description 保存用户名密码
     */
    saveUserAccountInfoToCookie() {
      // 判断用户是否勾选记住密码，如果勾选，向cookie中储存登录信息，
      // 如果没有勾选，储存的信息为空
      const { account, pwd } = this.loginForm
      if (this.remember) {
        if (this.$common.getCookie('pwd') === CryptoUtil.aesEncrypt(pwd)) return
        this.$common.setCookie('account', account, 7)
        this.$common.setCookie('pwd', CryptoUtil.aesEncrypt(pwd), 7)
      } else {
        this.$common.setCookie('account', '')
        this.$common.setCookie('prd1', '')
        this.$common.setCookie('prd2', '')
        this.$common.setCookie('prd3', '')
      }
    },
    // 初次登录修改密码成功
    setpasswordSuc() {
      this.isSetPassword = false
      this.resetCode()
    },
    // 语言切换
    i18nChange(lang) {
      this.SET_LANG(lang)
    },

    toggleIcon() {
      this.isShowPassword = !this.isShowPassword
    },
  },
}
</script>
<style lang="scss" scoped>
html:lang(my) .til {
  min-height: 40px;
}
html:lang(en) .til {
  min-height: 40px;
}
.black.login {
  color: #000;
}
.login {
  height: 100%;
  width: 100%;
  color: #fff;
  position: relative;
  // min-height: 720px;
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  -khtml-user-select: none; /*早期浏览器*/
  user-select: none;
  display: flex;
  align-items: center;
  //   transition: color 1s;
  .logo-img {
    font-size: 38px;
    position: absolute;
    z-index: 2;
    top: 10%;
    left: 8.16667%;
    color: $--color-primary;
    // font-size: 38px;
  }

  .lg-top {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items:start;
    // margin-top: 110px;
    position: relative;
    z-index: 2;
    padding-top: 5%;
  }
  .introduce_num {
    text-align: left;
    font-size: 16px;
    .num {
      margin-top: 21px;
      color: $--color-primary;
      letter-spacing: 0;
      word-spacing: 0;
      font-size: 36px;
      font-weight: 600;
    }
  }
}
.logo_introduce {
  position: relative;
  z-index: 2;
  box-sizing: border-box;
  width: 50%;
  padding-left: 4%;
  padding-right: 9%;
  word-break: break-all;
  > img{
    width: 90%;
  }
}
.login-box {
  position: relative;
  z-index: 2;
  // background: rgba(10, 0, 17, 0.2);
  box-sizing: border-box;
  width: 50%;
  padding-left: 16%;
  padding-right: 10%;
  height: auto;
  // margin-right:3%;
  // margin-left: 170px;
  // border-radius: 15px;
  .title {
    font-size: 28px;
    font-weight: 600;
    line-height: 30px;
    text-align: center;
    // letter-spacing: 6px;
    margin-bottom: 40px;
    height: 70px;
    color: #000;
  }
  .forget {
    cursor: pointer;
    color: $--color-primary;
    text-decoration: none;
    float: right;
  }
  .login-btn {
    width: 100%;
    padding: 0;
    height: 48px;
    line-height: 48px;
    border: 1px solid #000;
    border-radius: 36px;
    background-color: #6baa8b;
    color: #000;
    font-weight: bolder;
    // background: linear-gradient(90deg, rgba(230, 0, 18, 1) 0%, rgba(230, 0, 18, 1) 100%);
    margin-top: 40px;
    font-size: 18px;
  }
}
.introduce_main {
  font-size: 22px;
  line-height: 38px;
  margin-bottom: 0px;
  text-align: left;
  color: #000;
  // letter-spacing: 9px;
}
// @media only screen and (max-width: 1440px) {
//   .introduce_main {
//     font-size: 14px;
//   }
// }
</style>

<style lang="scss" rel="text/css">
$pl-input: 30px;
$mb-input: 20px;
$logo-h: 54px;
$border-color: #999999;
.lg-rgt-top {
  position: absolute;
  top: 20px;
  right: 20px;
}
::-webkit-input-placeholder {
  /* WebKit browsers */
  color: $border-color;
  font-size: 12px;
}
input:-internal-autofill-previewed,
input:-internal-autofill-selected {
  transition: background-color 5000s ease-in-out 0s !important;
}

::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: $border-color;
  font-size: 12px;
}

:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: $border-color;
  font-size: 12px;
}
html,
body {
  height: 100%;
}
.login {
  position: relative;
  .lm-i18n {
    position:absolute;
    right: 20%;
    top: -50px;
    width: 90px;
    .el-input__inner {
      padding: 0 15px !important;
      border-radius: 10px !important;
      border: 1px solid #000 !important;
      height: 32px !important;
      line-height: 32px !important;
    }
    .el-input__inner::placeholder,
    .el-input__inner::-webkit-input-placeholder {
      color: #fff;
    }
  }
  .el-form-item {
    margin-bottom: 30px;
  }
  input:-webkit-autofill {
    /* 选择历史记录的文字颜色*/
    -webkit-text-fill-color: #000 !important;
  }
  .el-input {
    width: 100% !important;
  }
  .el-form-item__label{
    font-size: 18px;
    color: #000;
    font-weight: 600;
    padding-bottom: 8px;
  }
  input.el-input__inner {
    background: transparent;
    border: 0;
    border-radius: 36px;
    border: 1px solid #000;
    color: #000 !important;
    height: 40px;
    line-height: 40px;
    padding: 0 25px;
    outline: none;
  }
  input.el-input__inner::placeholder{
    color: #696565;
  }
  .el-checkbox__inner{
    border-color: #000;
  }
  .el-checkbox__label {
    color: #000;
  }
  .el-input__suffix {
    right: 20px;
    line-height: 40px;
    color: #696565;
  }
  .el-carousel {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 0;
    width: 100%;
    min-width: 1200px;
    height: 100%;
  }
  .el-carousel__indicators {
    bottom: 6%;
  }
  .el-carousel__button {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: #d8d8d8;
  }
  .footer {
    position: absolute;
    bottom: 3%;
    text-align: center;
    font-size: 12px;
    font-family: ArialMT;
    width: 100%;
  }
  .el-input-group__append {
    color: #e60012;
    background: transparent;
    border: none;
    border-bottom: 1px solid #fff;
  }
  .el-form .el-input__inner {
    border-color: #000 !important;
  }
}
.brower-contain {
  box-sizing: border-box;
  position: absolute;
  top: 0;
  width: 100%;
  height: 45px;
  line-height: 45px;
  font-size: 14px;
  color: #fff;
  text-align: center;
  background-color: #333;
  z-index: 99;
  .brower-contain-text {
    margin-right: 30px;
  }
  .brower-contain-btn {
    @include base-color('clr');
    width: 60px;
    height: 30px;
    line-height: 30px;
    font-size: 16px;
    display: inline-block;
    text-align: center;
    background: rgba(255, 255, 255, 1);
    border-radius: 2px;
    cursor: pointer;
    text-decoration: none;
    color: #000;
  }
}
.toggleIcon {
  cursor: pointer;
  .icon-iconfont {
    font-size: 16px;
  }
}
</style>
